/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateProjectDomainInput
 */
export interface CreateOrUpdateProjectDomainInput {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateProjectDomainInput
     */
    hostName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateProjectDomainInput
     */
    isEnabled?: boolean;
}

/**
 * Check if a given object implements the CreateOrUpdateProjectDomainInput interface.
 */
export function instanceOfCreateOrUpdateProjectDomainInput(value: object): value is CreateOrUpdateProjectDomainInput {
    return true;
}

export function CreateOrUpdateProjectDomainInputFromJSON(json: any): CreateOrUpdateProjectDomainInput {
    return CreateOrUpdateProjectDomainInputFromJSONTyped(json, false);
}

export function CreateOrUpdateProjectDomainInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateProjectDomainInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
    };
}

export function CreateOrUpdateProjectDomainInputToJSON(json: any): CreateOrUpdateProjectDomainInput {
    return CreateOrUpdateProjectDomainInputToJSONTyped(json, false);
}

export function CreateOrUpdateProjectDomainInputToJSONTyped(value?: CreateOrUpdateProjectDomainInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'isEnabled': value['isEnabled'],
    };
}

